import { handleVersionMismatch } from 'actions/versionSync';
import { VersionMismatch } from 'services/BaseService';
import ExchangeService from 'services/ExchangeService';
import { fetchPlans } from 'actions/plans';
import {
  fetchOutfit,
  fetchMyself,
} from 'actions/myself';
import { fetchAvailable as fetchAvailableStorylets } from 'actions/storylet';
import { ITransactionRequest, ITransactionResponse } from 'types/exchange';

const service = new ExchangeService();

type TransactionActions = {
  failure: (e: any) => { type: string, error: boolean, status: number | undefined },
  requested: () => { type: string },
  success: (data: ITransactionResponse) => { type: string, payload: any },
};

export default function makeTransaction(type: 'buy' | 'sell', actions: TransactionActions) {
  const { requested, success, failure } = actions;

  const serviceAction: (transactionRequest: ITransactionRequest) => Promise<{ data: ITransactionResponse }> =
    type === 'buy'
    ? service.buyItems
    : service.sellItems;

  return (transactionData: ITransactionRequest) => async (dispatch: Function) => {
    dispatch(requested());
    try {
      const { data } = await serviceAction(transactionData);
      // Dispatch a 'success' action so that reducers know we've made a transaction
      dispatch(success(data));
      // Because bazaar transactions change our storylet availability, re-fetch available
      // slets
      // TODO: It is probably a better idea to null out storylet data than fetch,
      // since fetching has side effects
      dispatch(fetchAvailableStorylets());
      // And they also may impact plans, so fetch those as well
      dispatch(fetchPlans());
      // And they also affect our outfit/ourselves
      dispatch(fetchOutfit());
      dispatch(fetchMyself());
      return data;
    } catch (err) {
      if (err instanceof VersionMismatch) {
        handleVersionMismatch(err);
      }
      console.error(err);
      return dispatch(failure(err));
    }
  };
}